export default __webpack_public_path__ + "static/media/team.334752c8.jpg";